module.exports = __webpack_public_path__ + "static/media/studio7Low.8a9a7a89.hdr";